export class AppError extends Error {
  public status: number;
  public code?: string;

  constructor(message: string, status: number = 500, code?: string) {
    super(message);
    this.name = "AppError";
    this.status = status;
    this.code = code;
  }
}

export const handleApiError = (error: any): AppError => {
  if (error instanceof AppError) return error;

  if (error.name === "TypeError" && error.message.includes("fetch")) {
    return new AppError(
      "Erro de conexão. Verifique sua internet.",
      0,
      "NETWORK_ERROR"
    );
  }

  const status = error.status || 500;
  let message = "Erro interno do servidor";

  try {
    if (error.message) {
      message = error.message;
    }
  } catch {}

  return new AppError(message, status);
};

export const getErrorMessage = (error: unknown): string => {
  if (error instanceof AppError) return error.message;
  if (error instanceof Error) return error.message;
  return "Erro desconhecido";
};
